
import { getAllRoadmapStatusesSelectItems, RoadmapStatus } from "@/models/roadmap-item";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
export default Vue.extend({
	props: {
		label: String,
		value: Number as ()=> RoadmapStatus,
		fancy: Boolean,
		disabled: Boolean,
		items: {
			type: Array as ()=>ISelectItem<RoadmapStatus>[],
			default(){
				return getAllRoadmapStatusesSelectItems();
			}
		}
	},
	methods: {
		onInput(value:RoadmapStatus){
			this.$emit("input", value);
		}
	}
});
